function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M982.72,262.37l-34.46,0V231a17.83,17.83,0,0,0-17.81-17.82H892v-57a18,18,0,0,0-13.88-17.81l-11.57-2.51c-124-27.5-255.72-2.61-361.16,68.62l-12.48,8.68H66.6A17.83,17.83,0,0,0,48.79,231v31.33h-31A17.83,17.83,0,0,0,0,280.17V857.23A17.82,17.82,0,0,0,17.81,875H982.19A17.82,17.82,0,0,0,1000,857.23V280.17A17.7,17.7,0,0,0,982.72,262.37ZM964.9,297.94l-.26,541.4H572.13a74.71,74.71,0,0,0-9.69-22.85H930.67a17.82,17.82,0,0,0,17.82-17.81V297.94ZM534.38,839.34H462.59a39.56,39.56,0,0,1,14.11-15.85,40,40,0,0,1,57.68,15.85ZM856.66,701.29C740,678.6,616.49,701.86,516.3,766V240.83l9.15-6.58a431.39,431.39,0,0,1,331.21-63.9Zm13.2,39.9L879.5,743v-2.69a18.29,18.29,0,0,0,3.86-1.74,17.68,17.68,0,0,0,7.37-8.66l.76-2.31A17.31,17.31,0,0,0,892,723V247.64h20.65v532H561.31C655.18,729.09,766.11,715,869.86,741.19ZM84.46,780.83V248.89H480.71V780.83ZM66.64,816.46H434.87a76.61,76.61,0,0,0-9.76,22.88H35.78V297.94h13v500.7A17.83,17.83,0,0,0,66.64,816.46Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M432.19,300.42H142.06a18.64,18.64,0,1,0,0,37.27H432.15a18.64,18.64,0,0,0,0-37.27Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M142.1,441.47h290a18.64,18.64,0,0,0,0-37.27H142.06a18.64,18.64,0,0,0,0,37.27Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M432.19,508H142.06a18.64,18.64,0,1,0,0,37.28H432.19a18.64,18.64,0,0,0,0-37.28Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M321.63,611.77H142a18.47,18.47,0,0,0-13.09,5.4A18.62,18.62,0,0,0,142.1,649H321.63a18.63,18.63,0,1,0,0-37.25Z"
});

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.ed305c22.svg";
export { ForwardRef as ReactComponent };